<script lang="ts">
  import EmbedInterop from "./EmbedInterop"

  export let advisorId: string
  export let screenId: string

  let currentScreenId: string = screenId

  const sendScreenChange = (screenId: string) => {
    EmbedInterop.sendScreenChangeEvent(advisorId, screenId)
  }

  $: {
    if (currentScreenId !== screenId) {
      currentScreenId = screenId
      sendScreenChange(currentScreenId)
    }
  }
</script>
